import React, {useRef, useEffect} from 'react';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Downshift from 'downshift';
import styled, {css} from 'styled-components';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import RootRef from '@material-ui/core/RootRef';
import Button from './Button';

const Paper_ = styled(Paper)`
  position: absolute;
  z-index: 1;
  margin-top: 2px;
  left: 0;
  right: 0;
  max-height: 300px;
  overflow-y: auto;
  ${({top}) => top && css`
    top: ${top}px;
  `}
`

const Container = styled.div`
  display: inline-flex;
  flex-grow: 1;
  position: relative;
  ${({fullWidth}) => fullWidth && css`
    width: 100%;
  `}
`

function renderSuggestion({
  suggestion,
  index,
  itemProps,
  highlightedIndex,
  selectedItem
}) {
  const isHighlighted = highlightedIndex === index;
  const isSelected = selectedItem && (selectedItem.value === suggestion.value);
  return (
    <MenuItem
      {...itemProps}
      key={suggestion.label}
      selected={isHighlighted}
      component="div"
      style={isSelected ? {
        fontWeight: "bold",
      }:{}}
    >
      <ListItemText
        primary={suggestion.label}
        secondary={suggestion.sublabel || undefined} />
      {/* {suggestion.label} */}
    </MenuItem>
  );
}

function getSuggestions(value, suggestions) {
  return value.length === 0
    ? suggestions
    : suggestions.filter(suggestion => {
      return suggestion.label
        .toLowerCase()
        .includes(value.toLowerCase());
    });
}

// function renderInput(props,d) {
function CustomInput(props) {
  const {
    autoComplete,
    autoFocus,
    defaultValue,
    fullWidth,
    id,
    inputProps,
    InputProps,
    inputRef,
    multiline,
    name,
    onBlur,
    onChange,
    onFocus,
    placeholder,
    rows,
    rowsMax,
    type,
    value,
    d
  } = props;
  const { getInputProps } = d;
  // aqui as render props do downshift são armazenadas em fnRef
  // feito para possibilitar a chamada de funções do downshift em parent components
  let { fnRef } = props;
  useEffect(() => {
    fnRef.current = d;
  }, [])
  return (
    <Input
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      defaultValue={defaultValue}
      fullWidth={fullWidth}
      multiline={multiline}
      name={name}
      rows={rows}
      rowsMax={rowsMax}
      type={type}
      value={value}
      id={id}
      inputRef={inputRef}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      placeholder={placeholder}
      inputProps={inputProps}
      endAdornment={
        <InputAdornment position="end">
          <Button inputRef={inputRef} {...d} />
        </InputAdornment>
      }
      {...InputProps}
      {...getInputProps({
        placeholder
      })}
    />
  )
}

// SE QUISER CENTRALIZAR
// let inputStyle = { style: { textAlign: "center" } }
// let labelStyle = { style: {
//   textAlign: "center",
//   transformOrigin: "top center",
//   right: 0
// }}


export default function Seletor (props) {
  const {
    className,
    error,
    FormHelperTextProps,
    fullWidth,
    helperText,
    id,
    InputLabelProps,
    label,
    onChange,
    required,
    variant,
    suggestions,
    // selectedItem,
    ...other
  } = props;
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const formCtrlEl = useRef(null);
  const inputRef = useRef(null);
  // fnRef existe para armazenar as "render props" do downshift
  // estas render props são armazenadas via CustomInput
  const fnRef = useRef(null);
  const offset = useRef();
  React.useLayoutEffect(() => {
    offset.current = formCtrlEl.current.offsetHeight
  })
  return (
    <Downshift id="downshift-simple"
      onChange={e => {
        let r = null;
        if (fnRef && fnRef.current) r = fnRef.current
        onChange(e, r)
      }}
      itemToString={i => i ? i.label : ""}
    >
      {d => (
        <Container fullWidth={fullWidth} {...d.getRootProps()}>
          <RootRef rootRef={formCtrlEl}>
            <FormControl
              aria-describedby={helperTextId}
              className={className}
              error={error}
              fullWidth={fullWidth}
              required={required}
              variant={variant}
              {...other}
            >
              {label && (
                <InputLabel htmlFor={id} {...InputLabelProps}>
                  {label}
                </InputLabel>
              )}
              <CustomInput {...props} d={d} inputRef={inputRef} fnRef={fnRef} />
              {/* {renderInput({...props, inputRef, fnRef},d)} */}
              {helperText && (
                <FormHelperText id={helperTextId} {...FormHelperTextProps}>
                  {helperText}
                </FormHelperText>
              )}
            </FormControl>
          </RootRef>
          <div {...d.getMenuProps()}>
            {d.isOpen && (
              <Paper_ square top={offset.current}>
                {getSuggestions(d.inputValue,suggestions).map((suggestion, index) =>
                  renderSuggestion({
                    ...d,
                    suggestion,
                    index,
                    itemProps: d.getItemProps({ item: suggestion }),
                  }),
                )}
              </Paper_>
            )}
          </div>
        </Container>
      )}
    </Downshift>
      
  )
}
